import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Settings } from "../../models/interfaces/settings.model";
import { PledgeStatus } from "../../models/interfaces/pledgestatus.model";
import { PledgeType } from "../../models/interfaces/pledgetype.model";
import { MemberPage } from "../../pages/member/member";
import { PledgePage } from "../../pages/pledge/pledge";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-pledge_update",
  templateUrl: "pledge_update.html",
})
export class PledgeUpdatePage {
  public static readonly PLEDGE_UPD_ACCESS = "updatePledge";
  public static readonly PLEDGE_DEL_ACCESS = "deletePledge";
  private hasUpdPledgeAccess: boolean = false;
  private hasDelPledgeAccess: boolean = false;
  private pledgetype$: Observable<PledgeType[]>;
  private pledgeitem: Observable<Settings[]>;
  private pledgeitem$: any;
  private pledgeitem_by_name$ = [];
  private pledgestatus$: Observable<PledgeStatus[]>;
  private styleName: string ="";

  private id: string;
  private mb_hashname: string;
  private mb_photo: string;
  private hl_runno;
  private pl_id: number;
  private pl_date: string;
  private pt_name: string;
  private se_key_name: string;
  private pl_remark: string;
  private pl_qty: number;
  private se_key_value: number;
  private se_id: number;
  private pt_id: number;
  private ps_id: number;
  private pl_amount: number;
  private ps_name: string;
  private pledgeForm: FormGroup;
  private pItem;

  constructor(private configService: ConfigService,private authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, private db: DbserviceProvider,
              public alertCtrl: AlertController,
  ) {
    console.log("PledgeUpdatePage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");

    if (this.authService.currentUser) {
      this.hasUpdPledgeAccess = this.db.hasAccess(PledgeUpdatePage.PLEDGE_UPD_ACCESS);
      this.hasDelPledgeAccess = this.db.hasAccess(PledgeUpdatePage.PLEDGE_DEL_ACCESS);
    }

    this.pledgeForm = this.formBuilder.group({
      "hl_runno": ["", [Validators.required, Validators.min(1), Validators.max(9999)]],
      "mb_hashname": ["", [Validators.required]],
      "mb_photo": [""],
      "pl_amount": [""],
      "pl_date": ["", [Validators.required]],
      "pl_qty": ["", [Validators.required, Validators.min(1), Validators.max(100)]],
      "pl_remark": [""],
      "ps_id": ["", [Validators.required]],
      "ps_name": ["", [Validators.required]],
      "pt_id": ["", [Validators.required]],
      "pt_name": ["", [Validators.required]],
      "se_id": ["", [Validators.required]],
      "se_key_name": [""],
      "se_key_value": [""],
    });
  }

  private ionViewWillEnter() {
    console.log("PledgeUpdatePage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("PledgeUpdatePage onInitPage");
    this.pledgetype$ = this.db.dbCol({
      "action": "select", "mapObject": "pledge_type",
      "sqlExtended": " order by pledge_type.pt_order",
    });

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class='Pledge' order by settings.se_order",
    }).subscribe((ret) => {
      this.pledgeitem$ = ret;
      ret.forEach((element) => {
        this.pledgeitem_by_name$[element.se_id] = {};
        this.pledgeitem_by_name$[element.se_id].se_id = element.se_id;
        this.pledgeitem_by_name$[element.se_id].se_key_name = element.se_key_name;
        this.pledgeitem_by_name$[element.se_id].se_key_value = element.se_key_value;
      });
    });

    this.pledgestatus$ = this.db.dbCol({
      "action": "select", "mapObject": "pledge_status",
      "sqlExtended": " order by pledge_status.ps_order",
    });
    this.id = this.navParams.get("pledge").id;
    this.pl_id = this.navParams.data.pledge.pl_id;
    this.ps_id = this.navParams.data.pledge.ps_id;
    this.mb_hashname = this.navParams.data.pledge.mb_hashname;
    this.mb_photo = this.navParams.data.pledge.mb_photo;
    this.hl_runno = this.navParams.data.pledge.hl_runno;
    this.pl_date = this.navParams.data.pledge.pl_date;
    this.pt_name = this.navParams.data.pledge.pt_name;
    this.se_key_name = this.navParams.data.pledge.se_key_name;
    this.pl_remark = this.navParams.data.pledge.pl_remark;
    this.pl_qty = this.navParams.data.pledge.pl_qty;
    this.se_key_value = this.navParams.data.pledge.se_key_value;
    this.pl_amount = this.navParams.data.pledge.pl_amount;
    this.pt_id = this.navParams.data.pledge.pt_id;
    this.se_id = this.navParams.data.pledge.se_id;
    this.ps_name = this.navParams.data.pledge.ps_name;

    this.pledgeForm.controls.mb_hashname.setValue(this.mb_hashname);
    this.pledgeForm.controls.mb_photo.setValue(this.mb_photo);
    this.pledgeForm.controls.hl_runno.setValue(this.hl_runno);
    this.pledgeForm.controls.pl_date.setValue(this.pl_date);
    this.pledgeForm.controls.pt_name.setValue(this.pt_name);
    this.pledgeForm.controls.se_key_name.setValue(this.se_key_name);
    this.pledgeForm.controls.pt_id.setValue(this.pt_id);
    this.pledgeForm.controls.se_id.setValue(this.se_id);
    this.pledgeForm.controls.ps_id.setValue(this.ps_id);
    this.pledgeForm.controls.pl_remark.setValue(this.pl_remark);
    this.pledgeForm.controls.pl_qty.setValue(this.pl_qty);
    this.pledgeForm.controls.se_key_value.setValue(this.se_key_value);
    this.pledgeForm.controls.pl_amount.setValue(this.pl_amount);
    this.pledgeForm.controls.ps_name.setValue(this.ps_name);

    this.pItem = this.pledgeForm.value;
  }

  private ngOnDestroy() {
    console.log("PledgeUpdatePage ngOnDestroy");
    this.pledgetype$ = null;
  }

  private goback() {
    console.log("PledgeUpdatePage goback");
    this.navCtrl.pop();
  }

  private changeSelect_pi_name(pitem) {
    console.log("PledgeUpdatePage changeSelect_pi_name");
    this.se_key_value = this.pledgeitem_by_name$[pitem].se_key_value;
    this.se_id = this.pledgeitem_by_name$[pitem].se_id;
    this.pl_amount = this.se_key_value * this.pl_qty;
  }
  private onInput_pl_qty(_pl_qty) {
    console.log("PledgeUpdatePage onInput_pl_qty");
    this.pl_qty = _pl_qty;
    this.pl_amount = this.se_key_value * this.pl_qty;
  }

  private updatePledge(id: string, value: any) {
    console.log("PledgeUpdatePage updateMember");
    const formValues: any = {
      "hl_id": this.navParams.data.pledge.hl_id,
      "mb_id": this.navParams.data.pledge.mb_id,
      "pl_amount": value.pl_amount,
      "pl_date": value.pl_date,
      "pl_id": this.pl_id,
      "pl_qty": value.pl_qty,
      "pl_rate": value.pl_rate,
      "pl_remark": value.pl_remark,
      "ps_id": value.ps_id,
      "pt_id": value.pt_id,
      "se_id": value.se_id,
    };
    this.db.dbCol({ "action": "update", "mapObject": "pledge", ...formValues })
      .subscribe((ret) => {
        this.navCtrl.pop();
      });
  }

  private deletePledge(id: any) {
    console.log("PledgeUpdatePage deletePledge");
    this.showConfirm("Pledge", "Do you want to delete the Pledge?", id);
  }

  private showConfirm(title: string, message: string, id: string) {
    console.log("PledgeUpdatePage showConfirm");
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "dml", "mapObject": "dml",
              "query": "DELETE FROM pledge WHERE pl_id=" + this.pl_id,
            })
              .subscribe((ret) => {
                this.navCtrl.pop();
              });
          },
          "text": "Yes",
        },
        {
          "handler": () => {},
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pledge/pledge_update.ts